module.exports = __webpack_public_path__ + "img/2d57f3f.png";